var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { decamelize } from '../../../utils/camelize';
import FullScreenDialog from '../../molecules/FullScreenDialog';
import RoasterSelect from '../../organisms/RoasterSelect';
import { exclusiveLot as api } from '../../../api';
import { useRequest } from '../../../hooks/requestHook';
import MaterialTable from '../../MaterialTable';
import OriginalEditField from '../../MaterialTable/EditField';
import OrderedQuantity from '../../atoms/OrderedQuantity';
import { useExclusiveLotColumn } from '../../../hooks/useColumns';
var ExclusiveLotRoasterSelectDialog = function (_a) {
    var open = _a.open, onClose = _a.onClose, offerList = _a.offerList, offer = _a.offer, _b = _a.exclusiveLots, exclusiveLots = _b === void 0 ? [] : _b, onChange = _a.onChange;
    var _c = React.useState(false), loading = _c[0], setLoading = _c[1];
    var createExclusiveLot = useRequest(api.create);
    var updateExclusiveLot = useRequest(api.update);
    var deleteExclusiveLot = useRequest(api.destroy);
    var exclusiveLotColumns = useExclusiveLotColumn();
    var columns = React.useMemo(function () {
        return [
            exclusiveLotColumns.roasterName,
            exclusiveLotColumns.quantity,
            exclusiveLotColumns.typicaHandlingRate,
        ];
    }, [exclusiveLotColumns]);
    var handleCellUpdate = React.useCallback(function (newValue, oldValue, exclusiveLot, columnDef) { return __awaiter(void 0, void 0, void 0, function () {
        var data, response, nextExclusiveLots;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (newValue === oldValue || !columnDef.field)
                        return [2 /*return*/];
                    data = {
                        id: exclusiveLot.id,
                        exclusive_lot: (_a = {},
                            _a[decamelize(columnDef.field)] = newValue,
                            _a),
                    };
                    setLoading(true);
                    return [4 /*yield*/, updateExclusiveLot(data)];
                case 1:
                    response = _b.sent();
                    setLoading(false);
                    if (!response)
                        throw Error('response error');
                    nextExclusiveLots = [];
                    exclusiveLots.forEach(function (exclusiveLot) {
                        if (data.id === exclusiveLot.id) {
                            nextExclusiveLots.push(response);
                        }
                        else {
                            nextExclusiveLots.push(exclusiveLot);
                        }
                    });
                    onChange(nextExclusiveLots, response.offerRemainingQuantity);
                    return [2 /*return*/];
            }
        });
    }); }, [exclusiveLots, updateExclusiveLot]);
    var editable = React.useMemo(function () {
        if (offerList.status === 'active' || offerList.status === 'expired')
            return false;
        return true;
    }, [offerList]);
    var deletable = React.useCallback(function (exclusiveLot) { var _a; return ((_a = exclusiveLot.orderItem) === null || _a === void 0 ? void 0 : _a.id) === undefined; }, []);
    var cellEditable = React.useCallback(function (exclusiveLot, columnDef) {
        if (exclusiveLot.orderItem)
            return false;
        return columnDef.field !== 'roaster';
    }, []);
    var handleRowAdd = React.useCallback(function (exclusiveLot) { return __awaiter(void 0, void 0, void 0, function () {
        var data, response, nextExclusiveLots;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!offer)
                        return [2 /*return*/];
                    data = {
                        offer_id: offer.id,
                        exclusive_lot: {
                            roaster_id: exclusiveLot.roaster.id,
                            quantity: exclusiveLot.quantity,
                            typica_handling_rate: exclusiveLot.typicaHandlingRate,
                        },
                    };
                    setLoading(true);
                    return [4 /*yield*/, createExclusiveLot(data)];
                case 1:
                    response = _a.sent();
                    setLoading(false);
                    if (!response)
                        throw Error('response error');
                    nextExclusiveLots = [];
                    exclusiveLots.forEach(function (exclusiveLot) {
                        nextExclusiveLots.push(exclusiveLot);
                    });
                    nextExclusiveLots.push(response);
                    onChange(nextExclusiveLots, response.offerRemainingQuantity);
                    return [2 /*return*/];
            }
        });
    }); }, [offer, exclusiveLots, createExclusiveLot]);
    var handleRowDelete = React.useCallback(function (_a) {
        var id = _a.id;
        return __awaiter(void 0, void 0, void 0, function () {
            var data, response, nextExclusiveLots;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        data = { id: id };
                        setLoading(true);
                        return [4 /*yield*/, deleteExclusiveLot(data)];
                    case 1:
                        response = _b.sent();
                        setLoading(false);
                        if (!response)
                            throw Error('response error');
                        nextExclusiveLots = exclusiveLots.filter(function (exclusiveLot) { return data.id !== exclusiveLot.id; });
                        onChange(nextExclusiveLots, response.offerRemainingQuantity);
                        return [2 /*return*/];
                }
            });
        });
    }, [exclusiveLots, deleteExclusiveLot]);
    var EditQuantityField = function (props) {
        var value = props.value, onChange = props.onChange;
        return React.createElement(OrderedQuantity, { value: value, max: Math.pow(2, 31), onChange: onChange });
    };
    var EditRoasterField = function (props) {
        var value = props.value, onChange = props.onChange;
        return React.createElement(RoasterSelect, { value: value, onChange: onChange });
    };
    var EditField = function (props) {
        switch (props.columnDef.field) {
            case 'quantity':
                return React.createElement(EditQuantityField, __assign({}, props));
            case 'roaster':
                return React.createElement(EditRoasterField, __assign({}, props));
            default:
                return React.createElement(OriginalEditField, __assign({}, props));
        }
    };
    return (React.createElement(FullScreenDialog, { title: "Exclusive Lots", open: open, onClose: onClose },
        React.createElement(MaterialTable, { model: "exclusiveLot", title: 'Exclusive Lots', isLoading: loading, columns: columns, data: exclusiveLots, editable: editable
                ? {
                    isDeletable: deletable,
                    onRowAdd: handleRowAdd,
                    onRowDelete: handleRowDelete,
                }
                : undefined, cellEditable: editable
                ? {
                    onCellEditApproved: handleCellUpdate,
                    isCellEditable: cellEditable,
                    cellStyle: { color: 'black' }, // cancel out error color
                }
                : undefined, components: { EditField: EditField } })));
};
export default ExclusiveLotRoasterSelectDialog;
